export default __webpack_public_path__ + "static/media/btn-hover-baca-cerita.62fae431.png";